import { applicationApi } from './application'
import { appRegisterApi } from './appRegister'

export const applicationServe = {
  ...applicationApi,
  ...appRegisterApi,
}
